import { Typography, useTheme } from "@mui/material";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import useLanguage from "../../../hooks/useLanguage";
import { ChartBody, ChartPanel, EmptyMessage } from "../style";

export default function SourceChart({ text, data }) {
  const theme = useTheme();
  const [{ direction }] = useLanguage();
  const rtl = direction === "rtl";
  const palette = theme.palette;

  const rows = (data || []).map((d) => ({
    source: text.sources[d.source] || d.source,
    downloaded: d.downloaded ?? 0,
    published: d.published ?? 0,
  }));

  return (
    <ChartPanel>
      <Typography variant="h6">{text.charts.bySource}</Typography>
      <ChartBody>
        {rows.length === 0 ? (
          <EmptyMessage>{text.charts.empty}</EmptyMessage>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 8, right: 16, left: 0, bottom: 8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke={palette.borderColor.default} />
              <XAxis
                dataKey="source"
                stroke={palette.text.secondary}
                reversed={rtl}
                tick={{ fontSize: 12 }}
              />
              <YAxis
                stroke={palette.text.secondary}
                orientation={rtl ? "right" : "left"}
                tick={{ fontSize: 12 }}
                allowDecimals={false}
              />
              <Tooltip
                contentStyle={{
                  backgroundColor: palette.background.paper,
                  border: `1px solid ${palette.borderColor.default}`,
                  borderRadius: 8,
                  direction: rtl ? "rtl" : "ltr",
                }}
              />
              <Legend wrapperStyle={{ direction: rtl ? "rtl" : "ltr" }} />
              <Bar
                dataKey="downloaded"
                name={text.kpis.downloaded}
                fill={palette.primary.main}
              />
              <Bar
                dataKey="published"
                name={text.kpis.published}
                fill={palette.success?.main || "#2e7d32"}
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </ChartBody>
    </ChartPanel>
  );
}
